import React from 'react';
import Button from '../components/Button';
import { Eye } from 'lucide-react';
import {
  coalesce,
  getEquipmentStatus,
  getStatusColor,
  getStatusLabel,
  renderCell,
  renderCellDate,
} from './helpers';

function statusBadge(row) {
  const status = getEquipmentStatus(row);
  return (
    <span
      className={`inline-block whitespace-nowrap px-2 py-0.5 rounded-full text-xs font-medium ${getStatusColor(status)}`}
    >
      {getStatusLabel(status)}
    </span>
  );
}

function viewAction(onView, width = '10%') {
  return {
    header: 'Actions',
    accessor: 'actions',
    width,
    size: 'actions',
    actionCount: 1,
    actionMinCh: 12,
    render: (row) => (
      <Button variant="outline" size="sm" icon={Eye} onClick={() => onView(row)}>
        Voir
      </Button>
    ),
  };
}

/** Client « État extincteurs » — readable columns only; full fiche in modal / my-equipment. */
export function buildClientExtinguisherTableColumns(onView) {
  return [
    {
      header: 'Site',
      accessor: 'siteName',
      width: '11%',
      render: (row) => (
        <span className="text-sm text-gray-800 break-words">{renderCell(coalesce(row.siteName, '—'))}</span>
      ),
    },
    {
      header: 'N° série',
      accessor: 'serialNumber',
      width: '11%',
      render: (row) => (
        <span className="text-sm font-semibold text-gray-900 break-words">{renderCell(row.serialNumber)}</span>
      ),
    },
    {
      header: 'N° inventaire',
      accessor: 'inventoryNumber',
      width: '10%',
      render: (row) => (
        <span className="text-sm text-gray-700 break-words">{renderCell(row.inventoryNumber)}</span>
      ),
    },
    {
      header: 'Type extincteur',
      accessor: 'extinguisherType',
      width: '14%',
      nowrap: false,
      render: (row) => (
        <span className="text-sm text-gray-700 break-words">{renderCell(row.extinguisherType)}</span>
      ),
    },
    {
      header: 'Capacité',
      accessor: 'capacity',
      width: '8%',
      render: (row) => <span className="text-sm text-gray-700 whitespace-nowrap">{renderCell(row.capacity)}</span>,
    },
    {
      header: 'Emplacement',
      accessor: 'location',
      width: '16%',
      nowrap: false,
      render: (row) => (
        <span className="text-sm text-gray-700 break-words" title={coalesce(row.location, row.detailedLocation, '')}>
          {renderCell(coalesce(row.location, row.detailedLocation))}
        </span>
      ),
    },
    {
      header: 'Prochaine vérif.',
      accessor: 'nextMaintenanceDate',
      width: '12%',
      render: (row) => (
        <span className="text-sm text-gray-700 whitespace-nowrap">
          {renderCellDate(row.nextMaintenanceDate, 'dd/MM/yyyy')}
        </span>
      ),
    },
    {
      header: 'Statut',
      accessor: 'status',
      width: '10%',
      headerClassName: 'text-center',
      cellClassName: 'text-center',
      render: (row) => statusBadge(row),
    },
    viewAction(onView, '8%'),
  ];
}

/** Client « Équipements véhicules ». */
export function buildClientVehicleTableColumns(onView) {
  return [
    {
      header: 'Structure',
      accessor: 'structure',
      width: '12%',
      render: (row) => (
        <span className="text-sm text-gray-700 break-words">{renderCell(row.structure)}</span>
      ),
    },
    {
      header: 'Matricule',
      accessor: 'vehicleRegistration',
      width: '12%',
      render: (row) => (
        <span className="text-sm font-medium text-gray-900 break-words">
          {renderCell(row.vehicleRegistration)}
        </span>
      ),
    },
    {
      header: 'Affectation',
      accessor: 'affectation',
      width: '14%',
      nowrap: false,
      render: (row) => (
        <span className="text-sm text-gray-700 break-words">{renderCell(row.affectation)}</span>
      ),
    },
    {
      header: 'N° série',
      accessor: 'serialNumber',
      width: '11%',
      render: (row) => (
        <span className="text-sm text-gray-700 break-words">{renderCell(row.serialNumber)}</span>
      ),
    },
    {
      header: 'Type',
      accessor: 'extinguisherType',
      width: '14%',
      nowrap: false,
      render: (row) => (
        <span className="text-sm text-gray-700 break-words">{renderCell(row.extinguisherType)}</span>
      ),
    },
    {
      header: 'Prochaine vérif.',
      accessor: 'nextMaintenanceDate',
      width: '12%',
      render: (row) => (
        <span className="text-sm text-gray-700 whitespace-nowrap">
          {renderCellDate(row.nextMaintenanceDate, 'dd/MM/yyyy')}
        </span>
      ),
    },
    {
      header: 'Statut',
      accessor: 'status',
      width: '10%',
      headerClassName: 'text-center',
      cellClassName: 'text-center',
      render: (row) => statusBadge(row),
    },
    viewAction(onView, '15%'),
  ];
}
